module.exports = __webpack_public_path__ + "img/img-1.5a626058.png";